import { FixtureCard, FixtureCardRail } from '@carouselgg/nexus/fixture-card'
import { GameMark } from '@carouselgg/nexus/icon'
import { dayLabel, timeLabel, type WeekCard } from './homeModel'
import styles from './home.module.css'

/**
 * The fortnight ahead as one sideways row: matches you play, and competitions
 * you run starting. With nothing in it, the one card points at how to get a
 * match, so the row is never an empty box.
 */
export function WeekRow({ cards, now }: { cards: WeekCard[]; now: Date }) {
  return (
    <section aria-labelledby="home-week" className={styles.section} data-panel="Your week">
      <div className={styles.sectionHead}>
        <h2 id="home-week" className={styles.sectionTitle}>Your week</h2>
      </div>
      <FixtureCardRail>
        {cards.length === 0 && (
          <FixtureCard
            to="/compete"
            when="Nothing yet"
            dashed
            title="No matches yet"
            detail="Go solo or bring your squad, and your matches land here."
            footer="Find a competition →"
          />
        )}
        {cards.map((card, i) =>
          card.kind === 'match'
            ? (
              <FixtureCard
                key={card.id}
                to={card.to}
                when={card.tbd ? 'Date TBD' : dayLabel(card.at, now)}
                time={card.tbd ? undefined : timeLabel(card.at)}
                live={card.live}
                emphasis={i === 0}
                sides={[
                  { name: card.sides[0]?.name ?? 'TBD', logoUrl: card.sides[0]?.logoUrl, record: card.sides[0]?.record },
                  { name: card.sides[1]?.name ?? 'TBD', logoUrl: card.sides[1]?.logoUrl, record: card.sides[1]?.record, muted: true },
                ]}
                footer={
                  <>
                    <GameMark game={card.game} size={14} aria-hidden="true" />
                    <span className={styles.ellipsis}>{[card.subtitle, card.host].filter(Boolean).join(' · ')}</span>
                  </>
                }
              />
            )
            : (
              <FixtureCard
                key={card.id}
                to={card.to}
                when={dayLabel(card.at, now)}
                tag="You run it"
                dashed
                logo={card.logoUrl ? <img src={card.logoUrl} alt="" /> : undefined}
                title={card.title}
                detail={card.detail}
                footer="Manage →"
              />
            ),
        )}
      </FixtureCardRail>
    </section>
  )
}
